<template>
  <AdminShell>
    <h2>Dashboard</h2>

    <div class="cards">
      <div class="card">Tenants: {{ stats.tenants }}</div>
      <div class="card">Users: {{ stats.users }}</div>
      <div class="card">Flows: {{ stats.flows }}</div>
      <div class="card">Open Chats: {{ stats.openChats }}</div>
    </div>
  </AdminShell>
</template>

<script setup>
import { reactive, onMounted } from "vue";
import AdminShell from "@/components/admin/AdminShell.vue";
import { getTenants, getUsers, getFlows } from "@/services/admin";

const stats = reactive({
  tenants: 0,
  users: 0,
  flows: 0,
  openChats: 0,
});

onMounted(async () => {
  try {
    const [t, u, f] = await Promise.all([
      getTenants(),
      getUsers(),
      getFlows(),
    ]);

    stats.tenants = t.data?.tenants?.length || 0;
    stats.users = u.data?.users?.length || 0;
    stats.flows = f.data?.flows?.length || 0;
  } catch (e) {
    console.error(e);
  }
});
</script>

<style scoped>
.cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-top: 16px;
}
.card {
  background: white;
  padding: 18px;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,.06);
  font-weight: 700;
}
</style>
